import { Fragment, type ReactNode } from 'react'

const DEFAULT_LINK_CLASS =
  'text-xs text-blue-600 underline underline-offset-2 hover:text-primary/90'

function stripTrailingPunctFromUrl(s: string) {
  return s.replace(/[.,;:!?)]+$/, '')
}

export function renderTextWithLinks(
  text: string,
  options?: { linkClassName?: string }
) {
  const linkClassName = options?.linkClassName ?? DEFAULT_LINK_CLASS
  const matches = [...text.matchAll(/(https?:\/\/[^\s]+|www\.[^\s]+)/gi)]
  if (matches.length === 0) return text

  const nodes: ReactNode[] = []
  let last = 0
  let key = 0

  for (const m of matches) {
    const idx = m.index ?? 0
    const raw = m[0]
    if (idx > last) {
      nodes.push(
        <Fragment key={`t-${key++}`}>{text.slice(last, idx)}</Fragment>
      )
    }
    const cleaned = stripTrailingPunctFromUrl(raw)
    const tail = raw.slice(cleaned.length)
    const href = cleaned.startsWith('http') ? cleaned : `https://${cleaned}`
    nodes.push(
      <a
        key={`a-${key++}`}
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        className={linkClassName}
        onClick={(e) => e.stopPropagation()}
      >
        {cleaned}
      </a>
    )
    if (tail) {
      nodes.push(<Fragment key={`t-${key++}`}>{tail}</Fragment>)
    }
    last = idx + raw.length
  }
  if (last < text.length) {
    nodes.push(<Fragment key={`t-${key++}`}>{text.slice(last)}</Fragment>)
  }
  return nodes
}
